<template>
  <BaseFormCard ref="layer-form-card" width="500" icon="layers">
    <template #title>ชั้นข้อมูล</template>
    <template #body>
      <!-- <v-tabs v-model="layerTab" fixed-tabs hide-slider>
        <v-tab class="ml-0">Blackspot</v-tab>
        <v-tab>Heatmap</v-tab>
        <v-tab>Accident rate</v-tab>
      </v-tabs>

      <v-tabs-items v-model="layerTab">
        <v-tab-item class="pa-5">
          <v-layout row wrap ma-0>
            <v-flex xs6 pr-2>
              <p class="subtitle-2 mt-2 mb-2">ชื่อจุดอันตราย</p>
              <v-select
                v-model="dangerousNameSelect"
                :items="dangerousNameItems"
                no-data-text="ไม่พบข้อมูล"
                label="เลือกชื่อจุดอันตราย"
                class="card-border"
                flat
                solo
                hide-details
              ></v-select>
            </v-flex>
            <v-flex xs6 pl-2>
              <p class="subtitle-2 mt-2 mb-2">บริเวณจุดอันตราย</p>
              <v-select
                v-model="dangerousAreaSelect"
                :items="dangerousAreaItems"
                no-data-text="ไม่พบข้อมูล"
                label="เลือกบริเวณจุดอันตราย"
                class="card-border"
                flat
                solo
                hide-details
              ></v-select
            ></v-flex>
          </v-layout>
        </v-tab-item>

        <v-tab-item class="pa-5">
          <v-layout row wrap ma-0>
            <v-flex xs12>
              <p class="subtitle-2 mt-2 mb-2">ชื่อการคำนวณ</p>
              <v-select
                v-model="calculateNameSelect"
                :items="calculateNameItems"
                no-data-text="ไม่พบข้อมูล"
                label="เลือกชื่อการคำนวณ"
                class="card-border"
                flat
                solo
                hide-details
              ></v-select>
            </v-flex>
          </v-layout>
        </v-tab-item>

        <v-tab-item class="pa-5">
          <v-layout row wrap ma-0>
            <v-flex xs6 pr-2>
              <p class="subtitle-2 mt-2 mb-2">วันที่เริ่มต้น</p>
              <DatePicker v-model="startDate" ref="startDate" max="endDate" :min="startSearchDate"/>
            </v-flex>
            <v-flex xs6 pl-2>
              <p class="subtitle-2 mt-2 mb-2">วันที่สิ้นสุด</p>
              <DatePicker v-model="endDate" ref="endDate" :min="startDate || startSearchDate"
            /></v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs-items>-->
      <v-flex xs12 px-2>
        <v-card class="card-border mt-2" width="100%" height="100%" flat>
          <v-expansion-panels
            v-model="expansionPanel"
            focusable
            expand-icon="mdi-menu-down"
            accordion
            multiple
          >
            <!--v-expansion-panel>
              <v-expansion-panel-header>Black spot</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap ma-0>
                  <v-flex xs6 pr-2>
                    <p class="subtitle-2 mt-2 mb-2">ชื่อจุดอันตราย</p>
                    <v-select
                      v-model="dangerousNameSelect"
                      :items="dangerousNameItems"
                      no-data-text="ไม่พบข้อมูล"
                      label="เลือกชื่อจุดอันตราย"
                      class="card-border"
                      flat
                      solo
                      hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs6 pl-2>
                    <p class="subtitle-2 mt-2 mb-2">บริเวณจุดอันตราย</p>
                    <v-select
                      v-model="dangerousAreaSelect"
                      :items="dangerousAreaItems"
                      no-data-text="ไม่พบข้อมูล"
                      label="เลือกบริเวณจุดอันตราย"
                      class="card-border"
                      flat
                      solo
                      hide-details
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>Heatmap</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap ma-0>
                  <v-flex xs12 sm5 mt-4-->
            <!--p class="subtitle-2 mt-2 mb-2">ชื่อการคำนวณ</p>
                    <v-select
                      v-model="calculateNameSelect"
                      :items="calculateNameItems"
                      no-data-text="ไม่พบข้อมูล"
                      label="เลือกชื่อการคำนวณ"
                      class="card-border"
                      flat
                      solo
                      hide-details
                    ></v-select-->
            <!--v-checkbox
                      v-model="heatmap"
                      label="ข้อมูลบนแผนที่"
                      color="primary"
                      class="mt-0"
                      disabled
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel-->

            <!-- <v-expansion-panel>
              <v-expansion-panel-header> Accident rate </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap ma-0>
                  <v-flex xs6 pr-2>
                    <p class="subtitle-2 mt-2 mb-2">วันที่เริ่มต้น</p>
                    <DatePicker v-model="startAccidentDate" ref="startAccidentDate" max="endAccidentDate" :min="startSearchDate"/>
                  </v-flex>
                  <v-flex xs6 pl-2>
                    <p class="subtitle-2 mt-2 mb-2">วันที่สิ้นสุด</p>
                    <DatePicker v-model="endAccidentDate" ref="endAccidentDate" :min="startAccidentDate || startSearchDate"
                  /></v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>-->

            <v-expansion-panel>
              <v-expansion-panel-header>เพิ่มเติม</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap ma-0>
                  <v-flex xs12 sm5 mt-4>
                    <v-checkbox
                      v-model="irap"
                      label="iRap"
                      color="primary"
                      class="mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="itic"
                      label="iTIC"
                      color="primary"
                      class="mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="traffic"
                      label="ปริมาณจราจร"
                      color="primary"
                      class="mt-0"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm5 mt-sm-4>
                    <!--v-checkbox
                      v-model="road"
                      label="ถนน ทช."
                      color="primary"
                      class="mt-0"
                    ></v-checkbox-->
                    <v-checkbox
                      v-model="highway"
                      label="จุดก่อสร้าง ทล."
                      color="primary"
                      class="mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="km"
                      label="ตำแหน่งหลัก กม."
                      color="primary"
                      class="mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="accidentpin"
                      label="ข้อมูลอุบัติเหตุ"
                      color="primary"
                      class="mt-0"
                      @change="showorhidepin"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-flex>

      <v-flex
        xs12
        class="mt-3 mb-2 pa-5 d-flex align-center justify-sm-end flex-column flex-sm-row"
      >
        <!--v-btn
          :block="$vuetify.breakpoint.xsOnly"
          rounded
          outlined
          width="120"
          color="primary"
          class="mt-2 order-1 order-sm-0"
          >ยกเลิก</v-btn
        >
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          rounded
          width="120"
          color="primary"
          class="mt-2 ml-sm-2 order-0 order-sm-1"
          >ตกลง</v-btn
        -->

        <!-- hide input elements -->
        <v-flex v-show="false">
          <input ref="irap_kml_file" type="file" src="/src/assets/resources/irap.kml" />
        </v-flex>
      </v-flex>
    </template>
  </BaseFormCard>
</template>

<script>
import kmlToLongdoMap from '../../assets/resources/irap/kmltolongdomap';
// import togeojson from '../../assets/resources/togeojson';
import irapkmlfile from '!raw-loader!../../assets/resources/irap/irap.kml';
// import longdoHeatmap from '../../assets/resources/heatmap/longdomap-heatmap';
import BaseFormCard from './BaseFormCard.vue';
import DatePicker from '../global/DatePicker.vue';

export default {
  name: 'LayerFormCard',
  components: {
    BaseFormCard,
    DatePicker
  },
  data: () => ({
    //
    eventData: [],
    //
    expansionPanel: [0],
    //
    dangerousNameSelect: '',
    dangerousAreaSelect: '',
    calculateNameSelect: '',
    //
    dangerousNameItems: [],
    dangerousAreaItems: [],
    calculateNameItems: [],
    //
    // startDate: '',
    // endDate: '',
    //
    // startAccidentDate: '',
    // endAccidentDate: '',
    //
    irap: false,
    heatmap: false,
    itic: false,
    highway: false,
    gistda: false,
    traffic: false,
    km: false,
    road: false,

    irapOverlays: {},
    heatmapLayer: undefined,
    highwayOverlays: [],
    iticOverlays: [],
    trafficLayers: undefined,
    kmLayers: undefined,
    roadLayers: undefined,
    accidentpin: true
  }),
  props: {
    map: {
      type: Object,
      defaultL() {
        return {};
      }
    }
  },
  mounted() {
    this.initEventData();
  },
  methods: {
    deActivatebtn() {
      this.$refs['layer-form-card'].closeClicked();
    },
    initEventData() {
      const scope = this;
      const jsonpAdapter = require('axios-jsonp');

      const baseUrl = 'https://event.longdo.com/feed/json';

      this.axios({
        url: baseUrl,
        adapter: jsonpAdapter
      }).then(response => {
        // console.log(response);
        if (Array.isArray(response.data) && response.data.length > 0) {
          // scope.departmentItems = response.data.data;
          scope.eventData = response.data;
        }
      });
    },
    initIRap() {
      // console.log(this.$refs.irap_kml_file);
      // this.$refs.irap_kml_file.fileupload({
      //   url: '../../assets/resources/irap.kml',
      //   sequentialUploads: true
      // });

      // const reader = new FileReader();
      // reader.onload = function(event) {
      const overlays = kmlToLongdoMap(this.map, irapkmlfile, {
        geometryOptions: { lineWidth: 3 }
      });
      this.irapOverlays = overlays;
      // };
      // reader.readAsText(this.$refs.irap_kml_file.files);
      this.$emit('layer-change', { layer: 'irap', show: true });
    },
    removeIrap() {
      Object.keys(this.irapOverlays).forEach(key => {
        this.irapOverlays[key].forEach(overlay => {
          this.map.Overlays.remove(overlay);
        });
      });
      this.$emit('layer-change', { layer: 'irap', show: false });
    },
    initHeatmap() {
      const testData = {
        max: 10,
        data: [
          {
            lat: 13.087195,
            lon: 100.767761,
            value: 8
          },
          {
            lat: 13.804724,
            lon: 100.021301,
            value: 4
          }
        ]
      };
      const layer = new HeatmapOverlay({
        radius: 25,
        maxOpacity: 0.5,
        scaleRadius: true,
        useLocalExtrema: true
      });
      layer.setData(testData);
      this.map.Layers.add(layer);
      this.heatmapLayer = layer;
    },
    removeHeatmap() {
      this.map.Overlays.remove(this.heatmapLayer);
    },
    initHighWay() {
      if (this.highwayOverlays.length > 0) {
        this.highwayOverlays.forEach(overlay => {
          this.map.Overlays.add(overlay);
        });
        return;
      }

      this.highwayData.forEach(data => {
        const location = {
          lat: data.latitude,
          lon: data.longitude
        };
        const marker = new window.longdo.Marker(location, {
          icon: {
            urlHD:
              'https://traffic.longdo.com/sites/all/modules/traffic/images/icon_construction-l.png'
          },
          popup: {
            title: data.title,
            detail: data.description
          }
        });

        this.highwayOverlays.push(marker);
        this.map.Overlays.add(marker);
      });
    },
    removeHighWay() {
      this.highwayOverlays.forEach(overlay => {
        this.map.Overlays.remove(overlay);
      });
    },
    initItic() {
      this.map.Layers.add(longdo.Layers.TRAFFIC);
      this.$emit('layer-change', { layer: 'itic', show: true });
      if (this.iticOverlays.length > 0) {
        this.iticOverlays.forEach(overlay => {
          this.map.Overlays.add(overlay);
        });
        return;
      }

      this.iticData.forEach(data => {
        const location = {
          lat: data.latitude,
          lon: data.longitude
        };
        const marker = new window.longdo.Marker(location, {
          icon: {
            urlHD:
              // 'https://traffic.longdo.com/sites/all/modules/traffic/images/icon_construction-l.png'
              `https://traffic.longdo.com/sites/all/modules/traffic/images/icon_${data.icon}-l.png`
          },
          popup: {
            title: data.title,
            detail: data.description
          }
        });

        this.iticOverlays.push(marker);
        this.map.Overlays.add(marker);
      });
    },
    removeItic() {
      this.iticOverlays.forEach(overlay => {
        this.map.Overlays.remove(overlay);
      });
      this.$emit('layer-change', { layer: 'itic', show: false });
      this.map.Layers.remove(longdo.Layers.TRAFFIC);
    },
    initTraffic() {
      if (this.trafficLayers === undefined) {
        const layer = new longdo.Layer('tims:aadt', {
          type: longdo.LayerType.WMS,
          url: 'https://haims.doh.go.th/geoserver/gwc/service/wms',
          // zoomRange: { min: 6, max: 16 },
          refresh: 180,
          opacity: 1,
          weight: 10
        });

        this.trafficLayers = layer;
      }
      this.$emit('layer-change', { layer: 'aadt', show: true });
      this.map.Layers.add(this.trafficLayers);
    },
    removeTraffic() {
      this.map.Layers.remove(this.trafficLayers);
      this.$emit('layer-change', { layer: 'aadt', show: false });
    },
    initKm() {
      // const layer = new window.longdo.Layer('km', {
      //   type: longdo.LayerType.WMS,
      //   url: 'https://roadnet2.doh.go.th/geoserver/gwc/service/wms',
      //   zoomRange: { min: 12, max: 20 },
      //   weight: 2
      // });
      if (this.kmLayers === undefined) {
        const layer = new longdo.Layer('roadnet2:section_km', {
          type: longdo.LayerType.WMS,
          url: 'https://roadnet2.doh.go.th/geoserver/gwc/service/wms'
          // zoomRange: { min: 12, max: 20 },
          // weight: 14
        });
        this.kmLayers = layer;
      }
      this.map.Layers.add(this.kmLayers);
    },
    removeKm() {
      this.map.Layers.remove(this.kmLayers);
    },
    initRoad() {
      if (this.roadLayers === undefined) {
        const layer = new longdo.Layer('0', {
          type: longdo.LayerType.WMS,
          url: 'http://gis.drr.go.th/arcgis/services/DRR_Feature/MapServer/WmsServer',
          // refresh: 180,
          weight: 10
        });

        this.roadLayers = layer;
      }
      this.map.Layers.add(this.roadLayers);
    },
    removeRoad() {
      this.map.Layers.remove(this.roadLayers);
    },
    showorhidepin() {
      if (this.accidentpin) this.$emit('redrawpin');
      else this.$emit('clearpin');
    }
  },
  computed: {
    moreOptionsItemsLength() {
      return this.moreOptionsItems.length;
    },
    highwayData() {
      return this.eventData.filter(x => x.type === '2');
    },
    iticData() {
      return this.eventData.filter(x => x.type !== '2');
    }
  },
  watch: {
    irap(isChecked) {
      if (isChecked) {
        this.initIRap();
      } else if (this.irapOverlays) {
        this.removeIrap();
      }
    },
    heatmap(isChecked) {
      if (isChecked) {
        this.initHeatmap();
      } else if (this.heatmapLayer) {
        this.removeHeatmap();
      }
    },
    itic(isChecked) {
      if (isChecked) {
        this.highway = true;
        this.initItic();
      } else {
        this.highway = false;
        this.removeItic();
      }
    },
    highway(isChecked) {
      if (isChecked) {
        this.initHighWay();
      } else {
        this.removeHighWay();
      }
    },
    gistda(isChecked) {},
    traffic(isChecked) {
      if (isChecked) {
        this.initTraffic();
      } else {
        this.removeTraffic();
      }
    },
    km(isChecked) {
      if (isChecked) {
        this.initKm();
      } else {
        this.removeKm();
      }
    },
    road(isChecked) {
      if (isChecked) {
        this.initRoad();
      } else {
        this.removeRoad();
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
